import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z","key":"svg-0"}]]

const IconBrandUnsplash = createReactComponent('outline', 'brand-unsplash', 'BrandUnsplash', __iconNode);

export default IconBrandUnsplash;